import { Link } from "react-router-dom";

const BreadCrumb = ({ title  , previous ="" , previousLink = ""}) => {
    return <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
        {previousLink ? <>
        <Link to={'/'} className="hover:text-gray-700 cursor-pointer dark:hover:text-gray-200">Dashboard</Link> 
         <Link to={previousLink} className="hover:text-gray-700 cursor-pointer dark:hover:text-gray-200"> &nbsp; / &nbsp; {previous}</Link>
            </> : <>
          <span className="hover:text-gray-700  dark:hover:text-gray-200"> <Link to={'/'}>Dashboard</Link>   {previous ?? "Dashboard"}</span>
        </>}
        <span>/</span>
        <span className="text-gray-700 dark:text-gray-100">{title}</span>
    </div>
}
export default BreadCrumb;